import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SidebarBoarding from "../../components/SidebarDashboard";
import CustomNavbar from "../../components/CustomNavbar";
import { getFormResponses } from "../../redux/capacitacionDesarrollo/DNC/actions";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Modal,
  ListGroup,
  ButtonGroup,
  Badge,
} from "react-bootstrap";
import { BsEye, BsSearch } from "react-icons/bs";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

// Filtros de búsqueda
const filters = [
  { id: "codigo_empleado", desc: "Código de empleado" },
  { id: "año", desc: "Año de respuesta" },
];

function DNCManagement() {
  const dispatch = useDispatch();
  const [showSidebar, setShowSidebar] = useState(false);
  const onShowSidebar = () => setShowSidebar(!showSidebar);

  // Estado para paginación y filtros
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  // Estado para el modal de detalles
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);

  // Store
  const { loading, formResponses } = useSelector((store) => store.DNC);

  // Función para contar respuestas únicas por pregunta
  const countUniqueResponses = (respuestas) => {
    const uniqueQuestions = new Set();
    let count = 0;

    respuestas?.forEach((respuesta) => {
      const preguntaId = respuesta.pregunta.id;
      if (!uniqueQuestions.has(preguntaId)) {
        uniqueQuestions.add(preguntaId);
        count++;
      }
    });

    return count;
  };

  // Procesar los datos para la tabla
  const processedData = Array.isArray(formResponses?.results)
    ? formResponses.results.map((response) => ({
        ...response,
        respuestasCount: countUniqueResponses(response.respuestas),
      }))
    : [];

  const totalCount = formResponses?.total_respuestas || 0;
  const pages = formResponses?.total_pages || 1;

  const _getFormResponses = (
    offs = offset,
    lim = limit,
    tipo = tipoBusqueda.id,
    filt = filter
  ) => {
    const params = {
      page: Math.floor(offs / lim) + 1,
      page_size: lim,
    };

    if (filt) {
      params[tipo] = filt;
    }

    dispatch(getFormResponses(params));
  };

  // Efecto para cargar las respuestas
  useEffect(() => {
    _getFormResponses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, offset, limit]);

  const handlePagination = (newOffset) => {
    setOffset(newOffset);
    setCurrentPage(Math.ceil(newOffset / limit) + 1);
  };

  const onSearch = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const searchValue = filter;
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFormResponses(oOffset, limit, tipoBusqueda.id, searchValue);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFormResponses(oOffset, limit, tipoBusqueda.id, oSearch);
  };

  const handleViewDetails = (response) => {
    setSelectedResponse(response);
    setShowDetailModal(true);
  };

  const columns = [
    {
      Header: "Código",
      accessor: "empleado.codigo",
      Filter: "",
    },
    {
      Header: "Nombre",
      accessor: "empleado.nombre",
      Filter: "",
    },
    {
      Header: "Año",
      accessor: "año",
      Filter: "",
      Cell: ({ value }) => <Badge bg="info">{value}</Badge>,
    },
    {
      Header: "Total respuestas",
      accessor: "respuestasCount",
      Filter: "",
    },
    {
      Header: "Fecha",
      accessor: "fecha_respuesta",
      Filter: "",
      Cell: ({ value }) => new Date(value).toLocaleDateString(),
    },
    {
      Header: "Acciones",
      accessor: "acciones",
      Filter: "",
      Cell: ({ row }) => (
        <Button
          variant="outline-info"
          size="sm"
          onClick={() => handleViewDetails(row.original)}
        >
          <BsEye /> Ver respuestas
        </Button>
      ),
    },
  ];

  return (
    <>
      <SidebarBoarding show={showSidebar} onShowSidebar={onShowSidebar} />
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />

      <div>
        <div className="my-1 d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="ml-4">Gestión de Respuestas DNC</h5>
          <Form onSubmit={onSearch}>
            <Row className="justify-content-end align-items-center flex-nowrap">
              <Col>
                <p>
                  <b>Búsqueda por: </b>
                  {tipoBusqueda.desc}
                </p>
              </Col>
              <Col xs="auto">
                <Form.Control
                  name="filter"
                  id="filter"
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type={tipoBusqueda.id === "año" ? "number" : "search"}
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSearch(e);
                    }
                  }}
                />
              </Col>
              <Col xs="auto">
                <ButtonGroup>
                  <Button
                    onClick={() => seeAll()}
                    variant="light"
                    size="sm"
                    className="rounded-circle"
                  >
                    <i className="material-icons">list</i>
                  </Button>
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip>Seleccionar Filtrado</Tooltip>}
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => {
                                setTipoBusqueda(item);
                                setFilter("");
                              }}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                  <Button
                    variant="light"
                    size="md"
                    className="rounded-pill"
                    onClick={onSearch}
                  >
                    <BsSearch />
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center mt-4">
            <Spinner animation="border" role="status" />
          </div>
        ) : processedData && processedData.length > 0 ? (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <CustomTable columns={columns} data={processedData} />
              </Card.Body>
            </Card>
            <CustomPagint
              limit={limit}
              setLimit={setLimit}
              offset={offset}
              setOffset={handlePagination}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              dataLenght={totalCount}
              pages={pages}
              pagFunc={() => {}}
            />
          </>
        ) : (
          <Alert variant="info" className="my-4">
            No se encontraron respuestas.
          </Alert>
        )}

        {/* Modal para ver detalles de respuestas */}
        <Modal
          show={showDetailModal}
          onHide={() => setShowDetailModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Respuestas de {selectedResponse?.empleado.nombre} (
              {selectedResponse?.empleado.codigo}) - Año {selectedResponse?.año}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup variant="flush">
              {selectedResponse?.respuestas
                ?.reduce((acc, respuesta, index, array) => {
                  const preguntaSeleccionMultiple =
                    respuesta.pregunta.tipo === "seleccion_multiple";
                  const preguntaId = respuesta.pregunta.id;

                  if (preguntaSeleccionMultiple) {
                    const respuestasMismaPregunta = array
                      .filter((r) => r.pregunta.id === preguntaId)
                      .map((r) => r.valor_opcion)
                      .filter(Boolean);

                    if (!acc.find((item) => item.pregunta.id === preguntaId)) {
                      acc.push({
                        pregunta: respuesta.pregunta,
                        respuestaTexto: respuestasMismaPregunta.join(" - "),
                      });
                    }
                    return acc;
                  } else if (!acc.find((item) => item.id === respuesta.id)) {
                    acc.push({
                      id: respuesta.id,
                      pregunta: respuesta.pregunta,
                      respuestaTexto:
                        respuesta.valor_texto ||
                        respuesta.valor_opcion ||
                        "N/A",
                    });
                  }
                  return acc;
                }, [])
                .map((item) => (
                  <ListGroup.Item key={item.id || item.pregunta.id}>
                    <div className="mb-2">
                      <strong>Pregunta:</strong> {item.pregunta.texto}
                    </div>
                    <div>
                      <strong>Respuesta:</strong> {item.respuestaTexto}
                    </div>
                  </ListGroup.Item>
                ))}
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDetailModal(false)}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default DNCManagement;
